/**
 * Module dependencies
 */
import React from 'react';
import get from 'lodash/get';
import { StoreConsumer } from '../../store/context';

/**
 * withExperiments
 */
const experimentSelector = ({ experimentName, Component, ComponentWithExperiment }) => {
  const ExperimentSelector = props => (
    <StoreConsumer>
      {({ state }) => {
        const melidataEvent = get(state, 'track.melidata_event') || get(state, 'components.track.melidata_event');
        const frontendExperiments = get(state, 'frontend_experiments');

        const track = !!melidataEvent?.experiments?.[experimentName];
        const { value, forcedValue } = frontendExperiments?.[experimentName] || {};

        const showComponentWithExperiment = !!track && (forcedValue !== undefined ? forcedValue : value);

        return showComponentWithExperiment ? <ComponentWithExperiment {...props} /> : <Component {...props} />;
      }}
    </StoreConsumer>
  );

  ExperimentSelector.displayName = 'ExperimentSelector';

  return ExperimentSelector;
};

export default experimentSelector;
